module.exports = __webpack_public_path__ + "img/dbs.9864f394.png";